import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { MfaEnrollmentSetupDto } from '@app/data/dto';
import { AppIcon } from '@app/shared/controls/app-icon/app-icon';

@Component({
  selector: 'app-setup-mfa',
  imports: [AppIcon, FormsModule, TranslatePipe],
  templateUrl: './setup-mfa.component.html',
  styleUrl: './setup-mfa.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetupMfaComponent {
  readonly mfaSetup = input<MfaEnrollmentSetupDto | null>(null);
  readonly mfaQrCodeDataUrl = input<string>('');
  readonly mfaCode = input<string>('');
  readonly mfaWizardStep = input<1 | 2 | 3>(1);
  readonly mfaBusy = input<boolean>(false);
  readonly canEnableMfa = input<boolean>(false);
  readonly canDisableMfa = input<boolean>(false);

  readonly mfaCodeChange = output<string>();
  readonly startSetup = output<void>();
  readonly activate = output<void>();
  readonly disable = output<void>();
  readonly cancelled = output<void>();
}

